import { appConfig } from "@/config/app";

/**
 * Landing-page product tour: the 57-second narrated walkthrough of the app.
 * Assets live in public/tour/ (video, poster, English captions). preload="none"
 * keeps the 3 MB file off the critical path — nothing loads until a click.
 */
const ProductTour = () => (
  <section className="bg-white py-16 md:py-20" aria-labelledby="product-tour-heading">
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
      <div className="mb-8 text-center">
        <h2 id="product-tour-heading" className="text-3xl font-extrabold text-gray-900">
          See Lexi in action
        </h2>
        <p className="mt-3 text-base text-gray-600">A 57-second walkthrough: ask a Florida HOA question, get a cited answer, draft the letter.</p>
      </div>
      <div className="overflow-hidden rounded-xl border border-gray-200 bg-gray-900 shadow-sm">
        <video
          className="aspect-video h-full w-full"
          controls
          playsInline
          preload="none"
          poster="/tour/lexi-tour-poster.jpg"
          aria-label={`${appConfig.brand} product tour`}
        >
          <source src="/tour/lexi-tour.mp4" type="video/mp4" />
          <track kind="captions" srcLang="en" label="English" src="/tour/lexi-tour.en.vtt" default />
          Your browser does not support embedded video.
        </video>
      </div>
      <p className="mt-3 text-center text-xs text-gray-600">Recorded in the app. Lexi provides legal information, not legal advice.</p>
    </div>
  </section>
);

export default ProductTour;
